import React, { Component } from 'react'
import PropTypes from 'prop-types'

/**
 * A basic component that renders an image as a button with mouse over, click
 * and style props that can be provided by the parent.
 */
export default class ImgButton extends Component {
  /**
   * ThreeDBoxBtn c'tor
   */
  constructor (props) {
    super(props)
    this.state = { mouseOver: false }
  }

  /**
   * Render the component
   */
  render () {
    const thisStyle = {
      cursor: 'pointer'
    }

    const imageSource = this.state.mouseOver
      ? this.props.mouseOverSrc
      : this.props.imgSrc

    return (
      <img
        style={Object.assign({}, thisStyle, this.props.btnStyle)}
        src={imageSource}
        alt={this.props.altText}
        onMouseOver={() => {
          this.setState({ mouseOver: true })
        }}
        onMouseOut={() => {
          this.setState({ mouseOver: false })
        }}
        onClick={this.props.onButtonClick}
      />
    )
  }
}

ImgButton.propTypes = {
  imgSrc: PropTypes.string.isRequired,
  altText: PropTypes.string.isRequired,
  onButtonClick: PropTypes.func,
  btnStyle: PropTypes.object,
  mouseOverSrc: PropTypes.string
}



// WEBPACK FOOTER //
// ./src/components/foundation/ImgButton.js